import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import type { JiraNotificationChannelType } from '@atlassian/jira-relay/src/__generated__/notificationsConfigRow_personalSettingsNotificationsConfigTable_preference.graphql';

export function getCheckboxValues<C extends string>(channelsEnabled: readonly C[] | null) {
	return [...(channelsEnabled || [])].reduce(
		(acc, channel) => {
			acc[channel] = true;
			return acc;
		},
		// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
		{} as Partial<{
			[key in C]: boolean;
		}>,
	);
}

export function fireOnCompleteErrorAnalytics(
	errors: readonly {
		readonly message: string | null | undefined;
	}[],
	mutationLocation: 'Column' | 'Row' | 'Remove',
	configType: 'global' | 'project',
	channel?: JiraNotificationChannelType,
) {
	errors.forEach((error) => {
		fireErrorAnalytics({
			meta: {
				id: `mutateNotificationsConfig${mutationLocation}CompletedError`,
				packageName: 'jiraPersonalSettingsNotificationsConfigTable',
				teamName: 'jira-notifications-platform',
			},
			error: new Error(error?.message || 'Unknown Error'),
			sendToPrivacyUnsafeSplunk: true,
			attributes: {
				configType,
				channel,
			},
		});
	});
}

export function fireOnErrorAnalytics(
	error: Error,
	mutationLocation: 'Column' | 'Row' | 'Remove',
	configType: 'global' | 'project',
	channel?: JiraNotificationChannelType,
) {
	fireErrorAnalytics({
		meta: {
			id: `mutateNotificationsConfig${mutationLocation}`,
			packageName: 'jiraPersonalSettingsNotificationsConfigTable',
			teamName: 'jira-notifications-platform',
		},
		error,
		sendToPrivacyUnsafeSplunk: true,
		attributes: {
			configType,
			channel,
		},
	});
}
